import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { BaselineAlignment, PositionalAlignSelf } from '@wix/thunderbolt-becky-root'

/** Union type for both alignment properties */
type AlignmentProperty = StylePropertiesTypes.AlignSelf | StylePropertiesTypes.AlignItems

/** Shared Internal Converters */
const baselineAlignmentConverter = (prop: BaselineAlignment) => {
	return `baseline ${prop.order}`
}

const positionalAlignmentConverter = (prop: PositionalAlignSelf) => {
	return prop.value
}

/** Single Alignment Converter Map */
export const alignmentConverterMap = {
	BaselineAlignment: baselineAlignmentConverter,
	PositionalAlignment: positionalAlignmentConverter,
	UnsafePositionalAlignment: positionalAlignmentConverter,
	SafePositionalAlignment: positionalAlignmentConverter,
} as Record<string, (prop: AlignmentProperty) => string>
